import { createAllBlock, switchLoading, erreurBlockContainer } from "./blocks";

// https://grid.metafizzy.co/
const grid = $(".socialWall-slider");

fetch($("#message-erreur").data("site") + "/controller/rampa/reseauxSociaux")
    .then(response => response.json())
    .then(function(data) {
        if (data.error == undefined && data.length > 0) {
            var block = createAllBlock(data);

            grid.append(block);

            // script pour le owl carousel
            $(".socialWall-slider").owlCarousel({
                loop: true,
                margin: 32,
                dots: false,
                items: 1,
                animateOut: "fadeOut",
                nav: true,
                navText: [
                    '<i class="icon-chevron-left"></i>',
                    '<i class="icon-chevron-right"></i>'
                ],
                responsive: {
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    }
                }
            });
        } else {
            $("#message-erreur").append(
                erreurBlockContainer($("#message-erreur").data("erreur"))
            );
        }
    });
